var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.facet.name
    ? _c(
        "div",
        {
          staticClass: "filter__item",
          class: {
            "filter__item--price": _vm.facet.type === "price",
            "d-none": _vm.facet.id === "category" || _vm.facet.id === "feedback"
          }
        },
        [
          _vm.showHeadline
            ? _c(
                "button",
                {
                  staticClass: "filter__headline",
                  on: {
                    click: function() {
                      return (this$1.isOpen = !this$1.isOpen)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "filter__title" }, [
                    _vm._v(_vm._s(_vm.facetName))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isOpen,
                          expression: "!isOpen"
                        }
                      ],
                      staticClass: "filter__option-prev"
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.optionPreviewString) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "filter__headline-icon",
                      class: { "filter__headline-icon--active": _vm.isOpen }
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href": "#svg_arrow",
                          "xmlns:xlink": "https://www.w3.org/1999/xlink"
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("transition", [
            _vm.facet.type === "price"
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isOpen,
                        expression: "isOpen"
                      }
                    ]
                  },
                  [_c("item-filter-price")],
                  1
                )
              : _vm.facet.id == "feedback"
              ? _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOpen,
                      expression: "isOpen"
                    }
                  ]
                })
              : _vm.facet.id == "category" && _vm.isCatPageAndNotSearch
              ? _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOpen,
                      expression: "isOpen"
                    }
                  ]
                })
              : _vm.facet.id == 9 || _vm.facet.id == 5 || _vm.facet.id == 7
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isOpen,
                        expression: "isOpen"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter__slider" },
                      [
                        _c("div", { staticClass: "filter__slider-selection" }, [
                          _c("span", { staticClass: "filter__slider-min" }, [
                            _vm._v(_vm._s(_vm.currentMinValue))
                          ]),
                          _vm._v(" -\n                    "),
                          _c("span", { staticClass: "filter__slider-max" }, [
                            _vm._v(_vm._s(_vm.currentMaxValue))
                          ]),
                          _vm._v(" mm\n                ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "vue-slider",
                          _vm._b(
                            {
                              ref: "dimensionSlider",
                              attrs: { disabled: _vm.isLoading },
                              on: {
                                "drag-start": _vm.disableCallback,
                                "drag-end": _vm.enableCallback,
                                change: _vm.filterDimension,
                                callback: _vm.filterDimension
                              },
                              model: {
                                value: _vm.sliderConfig.value,
                                callback: function($$v) {
                                  _vm.$set(_vm.sliderConfig, "value", $$v)
                                },
                                expression: "sliderConfig.value"
                              }
                            },
                            "vue-slider",
                            _vm.sliderConfig,
                            false
                          )
                        )
                      ],
                      1
                    )
                  ]
                )
              : _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isOpen,
                        expression: "isOpen"
                      }
                    ],
                    staticClass: "filter__items",
                    class: { "filter__items-colors": _vm.facet.id == 10 }
                  },
                  [
                    _c("div", { staticClass: "filter__items-selection" }, [
                      _c("span", { staticClass: "filter__items-selected" }, [
                        _vm._v(_vm._s(_vm.selectedValue))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "filter__items-values" },
                      _vm._l(_vm.facets, function(value) {
                        return _c(
                          "div",
                          { key: value.id, staticClass: "form-check" },
                          [
                            _vm.facet.id == 10
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "filter__input-overlay",
                                    class: {
                                      "is-active": _vm.isSelected(value.id)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.updateFacet(value)
                                      }
                                    }
                                  },
                                  [
                                    _vm.getMapping(value.id) ==
                                    "placeholder.jpg"
                                      ? _c("div", {
                                          staticClass:
                                            "filter__input-overlay--inner",
                                          style:
                                            "background-color: #" +
                                            value.cssClass.split("-")[1]
                                        })
                                      : _c("div", {
                                          staticClass:
                                            "filter__input-overlay--inner",
                                          style:
                                            "background-image: url(https://www.weberbuero.de/documents/facet/" +
                                            _vm.facet.id +
                                            "/" +
                                            _vm.getMapping(value.id) +
                                            ")"
                                        })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-check-input styled-checkbox",
                              attrs: {
                                id: "option-" + value.id,
                                type: "checkbox",
                                disabled: _vm.isLoading || value.count <= 0
                              },
                              domProps: { checked: _vm.isSelected(value.id) },
                              on: {
                                change: function($event) {
                                  return _vm.updateFacet(value)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "option-" + value.id }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(value.name) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-badge" }, [
                              _vm._v(_vm._s(value.count))
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }